// External libraries
import React, { useEffect } from 'react';

// Internal modules
import { logger } from '@/lib';
import { ContactFieldsSection } from '@/components/ContactInformation';
import { PasswordlessOptionalSignupSubmission } from '../../../FormSubmission';

// this flow is only available in US
export const POMA = (): JSX.Element => {
  useEffect(() => {
    logger.info('rendering_poma_button_flow');
  }, []);

  return (
    <>
      <ContactFieldsSection />
      <PasswordlessOptionalSignupSubmission />
    </>
  );
};
